import Vue from 'vue'
import VueRouter from 'vue-router'
// import indexShouye from '../views/HomePage/indexShouye.vue'
import HomePage from '../views/HP/HomePage.vue'
import aboutUs from '../views/HP/aboutUs.vue'
// import HomePageCopy from '../views/HPcopy/HomePage.vue'
// import ceshiPage from '../views/ceshiPage.vue'
// import Login from '../views/Login/LoginPage.vue'
// import Authentication from '../views/Login/AuthenticationPage.vue'
import SelectedFreightRates from '../views/JXYJ/SelectedFreightRatesPage.vue'
import SearchResults from '../views/JXYJ/SearchResultsPage.vue'
import BookingSpace from '../views/JXYJ/BookingSpacePage.vue'
import OrderDetails from '../views/JXYJ/DetailsPage.vue'

import USToDoor from '../views/MJ/USToDoorPage.vue'
import USToDoorOrderDetails from '../views/MJ/USToDoorOrderDetails.vue'

import PlaceAnOrder from '../views/MJ/PlaceAnOrder.vue'
import Order from '../views/Order/OrderPage.vue'
import PriceInquiry from '../views/Price/PriceInquiryPage.vue'
import StareAt from '../views/Ding/StareAtPage.vue'
import Tool from '../views/Tool/ToolPage.vue'
import Message from '../views/Msg/MessagePage.vue'
import MessageDetail from '../views/Msg/MessageDetailPage.vue'
import MessageRecordDetail from '../views/Msg/MessageRecordDetailPage.vue'

import Template from '../views/Template/TemplatePage.vue'
import FreightTemplate from '../views/Template/FreightTemplatePage.vue'
import MarketTemplate from '../views/Template/MarketTemplatePage.vue'
import ToDoorTemplate from '../views/Template/ToDoorTemplatePage.vue'

import Member from '../views/VIP/MemberPage.vue'
import OpenMembership from '../views/VIP/OpenMembershipPage.vue'
import UserInfo from '../views/Wode/UserInfoPage.vue'
import Withdrawal from '../views/Wode/WithdrawalPage.vue'
import Recharge from '../views/Wode/RechargePage.vue'
import Transaction from '../views/Wode/TransactionPage.vue'
import Invoicing from '../views/Wode/InvoicingPage.vue'
import Invite from '../views/Wode/InvitePage.vue'


import Market from '../views/XCSC/SelectedFreightRatesPage.vue'
import MarketSearchResults from '../views/XCSC/SearchResultsPage.vue'
import MarketBookingSpace from '../views/XCSC/BookingSpacePage.vue'
import MarketOrderDetails from '../views/XCSC/DetailsPage.vue'

import ShipSPOT from '../views/CDSPOT/SelectedFreightRatesPage.vue'
import ShipSPOTSearchResults from '../views/CDSPOT/SearchResultsPage.vue'
import ShipSPOTBookingSpace from '../views/CDSPOT/BookingSpacePage.vue'
import ShipSPOTOrderDetails from '../views/CDSPOT/DetailsPage.vue'


import HTHomePage from '../views/HT/HP/HomePage.vue'


Vue.use(VueRouter)

const routes = [
  // 路由重新定向
  {
    path: '/index',
    redirect: "/"
  },
  // 测试页
  // {
  //   path: '/home',
  //   name: 'indexShouye',
  //   component: indexShouye,
  // },
  // 首页
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  // 关于我们
  {
    path: '/about-us',
    name: 'aboutUs',
    component: aboutUs,
  },
  // 登录
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login,
  // },
  // 认证
  // {
  //   path: '/authentication',
  //   name: 'Authentication',
  //   component: Authentication,
  // },
  // 邮件地址
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: OrderDetails,
  },
  // 精选运价
  {
    path: '/SelectedFreightRates',
    name: 'SelectedFreightRates',
    component: SelectedFreightRates,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 精选运价 查询结果
  {
    path: '/SearchResults',
    name: 'SearchResults',
    component: SearchResults,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 精选运价  订舱
  {
    path: '/BookingSpace',
    name: 'BookingSpace',
    component: BookingSpace,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 精选运价 订单详情
  {
    path: '/OrderDetails',
    name: 'OrderDetails',
    component: OrderDetails,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 现舱市场 Market
  {
    path: '/Market',
    name: 'Market',
    component: Market,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  }, 
  // 现舱市场 查询结果
  {
    path: '/MarketSearchResults',
    name: 'MarketSearchResults',
    component: MarketSearchResults,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 现舱市场  订舱
  {
    path: '/MarketBookingSpace',
    name: 'MarketBookingSpace',
    component: MarketBookingSpace,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 现舱市场 订单详情
  {
    path: '/MarketOrderDetails',
    name: 'MarketOrderDetails',
    component: MarketOrderDetails,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 船东SPOT Market
  {
    path: '/ShipSPOT',
    name: 'ShipSPOT',
    component: ShipSPOT,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  }, 
  // 船东SPOT 查询结果
  {
    path: '/ShipSPOTSearchResults',
    name: 'ShipSPOTSearchResults',
    component: ShipSPOTSearchResults,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 船东SPOT  订舱
  {
    path: '/ShipSPOTBookingSpace',
    name: 'ShipSPOTBookingSpace',
    component: ShipSPOTBookingSpace,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 船东SPOT 订单详情
  {
    path: '/ShipSPOTOrderDetails',
    name: 'ShipSPOTOrderDetails',
    component: ShipSPOTOrderDetails,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 美加到们
  {
    path: '/USToDoor',
    name: 'USToDoor',
    component: USToDoor,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  {
    path: '/PlaceAnOrder',
    name: 'PlaceAnOrder',
    component: PlaceAnOrder,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  {
    path: '/USToDoorOrderDetails',
    name: 'USToDoorOrderDetails',
    component: USToDoorOrderDetails,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 订单详情
  {
    path: '/Order',
    name: 'Order',
    component: Order,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 询价记录
  {
    path: '/PriceInquiry',
    name: 'PriceInquiry',
    component: PriceInquiry,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 盯舱宝
  {
    path: '/StareAt',
    name: 'StareAt',
    component: StareAt,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 工具
  {
    path: '/Tool',
    name: 'Tool',
    component: Tool,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 消息通知
  {
    path: '/Message',
    name: 'Message',
    component: Message,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 消息通知展开详情
  {
    path: '/MessageDetail',
    name: 'MessageDetail',
    component: MessageDetail,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  {
    path: '/MessageRecordDetail',
    name: 'MessageRecordDetail',
    component: MessageRecordDetail,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 我的模版
  {
    path: '/Template',
    name: 'Template',
    component: Template,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 新建模版
  {
    path: '/FreightTemplate',
    name: 'FreightTemplate',
    component: FreightTemplate,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  {
    path: '/MarketTemplate',
    name: 'MarketTemplate',
    component: MarketTemplate,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  {
    path: '/ToDoorTemplate',
    name: 'ToDoorTemplate',
    component: ToDoorTemplate,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 会员中心
  {
    path: '/Member',
    name: 'Member',
    component: Member,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 开通会员
  {
    path: '/OpenMembership',
    name: 'OpenMembership',
    component: OpenMembership,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 我的  用户信息
  {
    path: '/UserInfo',
    name: 'UserInfo',
    component: UserInfo,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 提现
  {
    path: '/Withdrawal',
    name: 'Withdrawal',
    component: Withdrawal,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 充值
  {
    path: '/Recharge',
    name: 'Recharge',
    component: Recharge,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 交易详情
  {
    path: '/Transaction',
    name: 'Transaction',
    component: Transaction,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 开票详情 
  {
    path: '/Invoicing',
    name: 'Invoicing',
    component: Invoicing,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 邀请好友
  {
    path: '/Invite',
    name: 'Invite',
    component: Invite,
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  // 后台
  {
    path: "/ht/authentication",
    component: () => import("@/views/HT/Login/AuthenticationPage.vue"),
    meta: {
      requiresAuth: true,
      content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    },
  },
  {
    path: '/ht',
    name: 'HTHomePage',
    component: HTHomePage,
    redirect: "/ht/index-main",
    children:[
      // 首页  工作台
      {
        path: "index-main",
        name:'index-main',
        component: () => import("@/views/HT/HP/WorkbenchesPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 舱位管理 精选运价
      {
        path: "freight",
        name:'freight',
        component: () => import("@/views/HT/CW/FreightRatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 订单管理 快速发布
      {
        path: "freightQuick",
        name:'freightQuick',
        component: () => import("@/views/HT/Quick/FreightRateQuickPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 舱位管理  现舱市场
      {
        path: "market",
        name:'market',
        component: () => import("@/views/HT/CW/MarketPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 舱位管理 新建舱位发布
      {
        path: "newcabin",
        name:'newcabin',
        component: () => import("@/views/HT/CW/NewCabinPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 舱位管理 新建舱位发布  快速发布
      {
        path: "batchrelease",
        name:'batchrelease',
        component: () => import("@/views/HT/CW/BatchReleasePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 订单管理 精选运价
      {
        path: "freightOrder",
        name:'freightOrder',
        component: () => import("@/views/HT/Order/FreightOrderPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 订单管理 现舱市场
      {
        path: "marketOrder",
        name:'marketOrder',
        component: () => import("@/views/HT/Order/MarketOrderPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 订单管理 订单详情
      {
        path: "orderDetail",
        name:'orderDetail',
        component: () => import("@/views/HT/Order/DetailsPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账单变动记录
      {
        path: "billChangesRecord",
        name:'billChangesRecord',
        component: () => import("@/views/HT/Order/BillChangesRecordPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账单变动  更新账单
      {
        path: "billChanges",
        name:'billChanges',
        component: () => import("@/views/HT/Order/BillChangesPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 消息通知
      {
        path: "message",
        name:'message',
        component: () => import("@/views/HT/Msg/MessagePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 消息通知详情
      {
        path: "messageDeatil",
        name:'messageDeatilHt',
        component: () => import("@/views/HT/Msg/MessageDetailPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账单管理
      {
        path: "billManagement",
        name:'billManagement',
        component: () => import("@/views/HT/Order/BillingManagementPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 运费模版
      {
        path: "template",
        name:'template',
        component: () => import("@/views/HT/Template/TemplatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 新建模版
      {
        path: "newtemplate",
        name:'newtemplate',
        component: () => import("@/views/HT/Template/NewTemplatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 批量发布模版
      {
        path: "batchtemplate",
        name:'batchtemplate',
        component: () => import("@/views/HT/Template/BatchReleaseTemplatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 新建模版 批量发布模版
      {
        path: "newbatchtemplate",
        name:'newbatchtemplate',
        component: () => import("@/views/HT/Template/NewBatchReleaseTemplatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 运费模版
      {
        path: "agentTemplate",
        name:'agentTemplate',
        component: () => import("@/views/HT/Template/AgentTemplatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 运费模版
      {
        path: "agentTemplate",
        name:'agentTemplate',
        component: () => import("@/views/HT/Template/AgentTemplatePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },{
        path: "today",
        name:'today',
        component: () => import("@/views/HT/Template/TodayPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  个人资料
      {
        path: "personal",
        name:'personal',
        component: () => import("@/views/HT/Settings/PersonalPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  我的钱包
      {
        path: "wallet",
        name:'wallet',
        component: () => import("@/views/HT/Settings/WalletPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  我的钱包  充值
      {
        path: "recharge",
        name:'recharge',
        component: () => import("@/views/HT/Settings/RechargePage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  我的钱包  提现
      {
        path: "withdrawal",
        name:'withdrawal',
        component: () => import("@/views/HT/Settings/WithdrawalPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  我的钱包  提现详情
      {
        path: "transaction",
        name:'transaction',
        component: () => import("@/views/HT/Settings/TransactionPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  我的钱包  开票详情
      {
        path: "invoicing",
        name:'invoicing',
        component: () => import("@/views/HT/Settings/InvoicingPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置  会员权益
      {
        path: "member",
        name:'member',
        component: () => import("@/views/HT/Settings/MemberPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置 操作日志
      {
        path: "operationLog",
        name:'operationLog',
        component: () => import("@/views/HT/Settings/OperationLogPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置 子账号
      {
        path: "subAccount",
        name:'subAccount',
        component: () => import("@/views/HT/Settings/SubAccountPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
      // 账号设置 平台协议
      {
        path: "agreement",
        name:'agreement',
        component: () => import("@/views/HT/Settings/AgreementPage.vue"),
        meta: {
          requiresAuth: true,
          content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
      },
    ]
  },

  // 请在电脑PC端下访问  mobile
  // {
  //   path: "/PC",
  //   component: () => import("@/views/HT/Login/AuthenticationPage.vue"),
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes
// })

// meta: {
//   requiresAuth: true,
//   content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
// },

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

//获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err);
}


router.beforeEach((to, from, next) => {
  const isLoginRequired = to.matched.some(record => record.meta.requiresAuth)
  const isLogin = localStorage.getItem('isLogin')
  console.log('to,from,next',to,from);
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  console.log(11111,'login',isLoginRequired,!isLogin);
  if (isLoginRequired && !isLogin) {
    next('/') // 未登录则重定向到登录页面
  } else {
     // 已登录，或者不需要登录的页面，正常导航
    if(to.matched[0].path=='/ht'){
      if(userInfo.supplier_is_authentication==2){
        next()
      }else{
        next('/ht/authentication')
      }
    }else{
      next()
    }
  }
})

router.afterEach((to, from) => {
  // 在路由切换后滚动到页面顶部
  console.log('路由切换',to.path,from.path);
  if (to.path !== from.path) {
    window.scrollTo(0, 0); // 将滚动条位置设置到页面最顶部
  }
})



export default router
